<div class="menuTriger" id="headTriger">
  <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffectj (click)="showHeader()">
    <i class="fa fa-arrow-up" id="headTrigerIcon"></i>
  </a>
</div>
<div *ngIf='(viewState$ | async) as v'>
  <div *ngIf='v.isLoading'>
    <div class="alert alert-info" role="alert">
      <div class="text-center">
        <h3><strong>Loading Board...</strong>
        </h3>
      </div>
    </div>
  </div>
  <div *ngIf='v.isError'>
    <div class="alert alert-danger" role="alert">
      <div class="text-center">
        <h3><strong>Board Error - {{v.errorMessage}}</strong>
        </h3>
      </div>
    </div>
  </div>
  <div *ngIf='errorMessage.length > 0 && showErrorBox'>
    <div class="alert alert-danger" role="alert">
      <div class="text-center">
        <h3><strong>!!! {{errorMessage}} !!!</strong>
        </h3>
      </div>
    </div>
  </div>
  <div *ngIf='v.isLoaded'>
    <div *ngIf='v.isNotFound'>
      <div class="alert alert-danger" role="alert">
        <div class="text-center">
          <h3><strong>Board Data - Not found.</strong>
          </h3>
        </div>
      </div>
    </div>
    <div *ngIf='v.minutesFromLastUpdate > 5'>
      <div class="alert alert-danger" role="alert">
        <div class="text-center">
          <h3><strong>Board Data not updated for {{v.minutesFromLastUpdate}} minutes</strong>
          </h3>
        </div>
      </div>
    </div>
    <div *ngIf='!v.isNotFound'>
      <div class="d-block d-md-none">
        <div class="col-lg-4 panel-title mb-2 mt-3">
          <div class="px-4 py-2 white-text blue-gradient text-center" style="border-radius: 5px;">
            <div style="font-size: 24px; font-weight:bold ">{{v.boardName}}</div>
            <div style="font-size: 8px">{{v.LastUpdated | date:'medium'}}</div>
          </div>
        </div>

        <div *ngFor="let s of v.skillsets">
          <mdb-card cascade="true" narrower="true" class="pt-3">
            <div class="row">
              <div class="col-8 col-sm-6">
                <div class="view view-cascade gradient-card-header blue-gradient narrower pb-0 pt-2">
                  <h4 class="card-header-title">{{s.Name}}</h4>
                </div>
              </div>
            </div>
            <mdb-card-body cascade="true" class="pb-0 pt-2">
              <mdb-card-text>
                <div class="row">
                  <div class="col-6">
                    <div class="column-numeric text-center" [ngClass]="{'cell-warning warning-color-dark' : s.WarningLevel && s.WarningLevel === 1, 
                                                'cell-danger danger-color-dark': s.WarningLevel && s.WarningLevel === 2, 
                                                '': !s.WarningLevel }"><b>CIQ </b>{{s.CallsWaiting}}</div>
                  </div>
                  <div class="col-6">
                    <div class="column-numeric text-center" [ngClass]="{'cell-warning warning-color-dark' : s.WarningLevel && s.WarningLevel === 1, 
                                'cell-danger danger-color-dark': s.WarningLevel && s.WarningLevel === 2, 
                                '': !s.WarningLevel }"><b>MWT </b>{{s.MaxWaitTime}}</div>
                  </div>
                  <div class="col-6">
                    <div class="column-numeric text-center"><b>ANS </b>{{s.CallsAnswered}}</div>
                  </div>
                  <div class="col-6">
                    <div class="column-numeric text-center"><b>ABN </b>{{s.CallsAbandoned}}</div>
                  </div>
                </div>
              </mdb-card-text>
            </mdb-card-body>
          </mdb-card>
        </div>
      </div>

      <div class="d-none d-md-block">
        <mdb-card cascade="true" narrower="true">
          <div
            class="view view-cascade gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center">
            <div class="last-update-date">{{v.LastUpdated}}</div>
            <div class="board-name" id="boardName" (click)="boardNameClick()">{{v.boardName}}</div>
            <div>
                <a *ngIf='errorMessage.length > 0' mdbBtn floating="true" size="sm" gradient="peach" mdbWavesEffectj (click)="errorBoxTriger()">
                    <i class="fa fa-exclamation"></i>
                  </a>
              <a mdbBtn floating="true" size="sm" gradient="blue" mdbWavesEffectj (click)="soundTriger()">
                <i class="fa fa-volume-off" id="soundTrigerIcon"></i>
              </a>
            </div>
          </div>
          <!--
            <div *ngIf='v.scrollingMessage.length > 0' class="div-desktop">
                <div class="scroll-text scroll-left" style="height: 50px; font-size: 50px; white-space: nowrap;"> <p>{{v.scrollingMessage}}</p></div>
            </div>
            -->
          <mdb-card-body class="card-body-top-pos">
            <mdb-card-text>
              <div class="table-responsive">
                <table class="table large-header" mdbTable small="true" striped="true">
                  <thead>
                    <tr>
                      <th class="theader-style header-column-alphanumeric">Skillset</th>
                      <th class="theader-style header-column-numeric">Queued</th>
                      <th class="theader-style header-column-numeric">Max Wait</th>
                      <th class="theader-style header-column-numeric">Answered</th>
                      <th class="theader-style header-column-numeric">Abandoned</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let s of v.skillsets">
                      <td *ngIf='s.WarningLevel && s.WarningLevel === 1'>
                        <div class="tbody-style column-alphanumeric cell-warning warning-color-dark">
                          {{s.Name}}
                        </div>
                      </td>
                      <td *ngIf='s.WarningLevel && s.WarningLevel === 2'>
                        <div class="tbody-style column-alphanumeric cell-danger danger-color-dark">
                          {{s.Name}}
                        </div>
                      </td>
                      <td *ngIf='!s.WarningLevel'>
                        <div class="tbody-style column-alphanumeric">
                          {{s.Name}}
                        </div>
                      </td>
                      <!-- Calls Waiting -->
                      <td *ngIf='s.WarningLevel && s.WarningLevel === 1'>
                        <div class="tbody-style column-numeric cell-warning warning-color-dark">{{s.CallsWaiting}}</div>
                      </td>
                      <td *ngIf='s.WarningLevel && s.WarningLevel === 2'>
                        <div class="tbody-style column-numeric cell-danger danger-color-dark">{{s.CallsWaiting}}</div>
                      </td>
                      <td *ngIf='!s.WarningLevel'>
                        <div class="tbody-style column-numeric">{{s.CallsWaiting}}</div>
                      </td>
                      <!-- Waiting Time -->
                      <td *ngIf='s.WarningLevel && s.WarningLevel === 1'>
                        <div class="tbody-style column-numeric cell-warning warning-color-dark">{{s.MaxWaitTime}}</div>
                      </td>
                      <td *ngIf='s.WarningLevel && s.WarningLevel === 2'>
                        <div class="tbody-style column-numeric cell-danger danger-color-dark">{{s.MaxWaitTime}}</div>
                      </td>
                      <td *ngIf='!s.WarningLevel'>
                        <div class="tbody-style column-numeric">{{s.MaxWaitTime}}</div>
                      </td>
                      <!-- -->
                      <td class="tbody-style column-numeric">{{s.CallsAnswered}}</td>
                      <td [ngClass]="{'font-attention' : s.CallsAbandoned > 0}">
                        <div class="tbody-style column-numeric">{{s.CallsAbandoned}}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
      </div>
    </div>
  </div>